module.exports = __webpack_public_path__ + "static/media/about-hero.b1d0f45c.jpg";